<template>
  <div
    @click="openTermsOfService()"
    class="text">
    {{ $l.termsAndConditionsIsHere }}
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  methods: {
    openTermsOfService: function () {
      window.open(this.$l.urlTermsAndConditions, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.text {
  &:hover {
    border-bottom: 1px solid white;
  }
}
</style>
